<template>
  <form class="form-box" v-on:submit.prevent="onSubmit">
    <b-container class="container-box">
      <b-row class="no-gutters">
        <b-col>
          <h1 class="font-weight-bold header-main text-uppercase mb-3">
            ตั้งค่าการกระจายสินค้า
          </h1>
        </b-col>
      </b-row>
      <div class="d-flex flex-row w-100 header-purple">
        <div class="w-50 d-flex flex-row">
          <p class="mb-0 font-weight-bold pr-4">สัดส่วนการกระจายสินค้า (%)</p>
        </div>
      </div>
      <div class="bg-white">
        <b-table
          class="text-center mb-0 bg-white"
          responsive
          :items="items"
          :fields="fields"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template
            v-for="field in fields"
            v-slot:[`cell(${field.key})`]="data"
          >
            <div
              :key="field.key"
              v-if="field.key == 'totalPercent'"
              class="error-container"
            >
              <p
                :class="[data.item.totalPercent > 100 ? 'text-danger' : '']"
                class="mb-0"
              >
                {{ data.item.totalPercent }}%
              </p>
            </div>
            <div v-else :key="field.key">
              <div>
                <InputText
                  :id="'inputPercent' + field.key + data.index"
                  textFloat=""
                  placeholder=""
                  type="number"
                  :name="field.key"
                  isRequired
                  v-model="data.item[field.key]"
                  :isValidate="
                    $v.items.$each.$iter[data.index][field.key].$error
                  "
                  :v="$v.items.$each.$iter[data.index][field.key]"
                  @input="sumPercent(data.index)"
                />
              </div>
            </div>
          </template>

          <template #cell(percent)="data">
            <p class="m-0">{{ data.item.percent }}</p>
          </template>
        </b-table>

        <span class="text-error" v-if="isWarningDup">
          สัดส่วนเหลือน้อยไม่สามารถซ้ำกันได้
        </span>

        <div class="mt-2 p-2 bg-white d-flex flex-row w-100">
          <div class="w-100 pl-2 pb-1">
            <b-button
              @click="cancle()"
              class="button-container btn-main-2"
              id="cancleInventoryAutoConfig"
              >ยกเลิก</b-button
            >
          </div>
          <div class="pr-2 pb-1 w-100 d-flex justify-content-end">
            <b-button
              type="submit"
              class="button-container btn-main"
              id="submitInventoryAutoConfig"
              >บันทึก</b-button
            >
          </div>
        </div>
      </div>
    </b-container>
    <ModalLoading ref="modalLoadingUpdatePercent" :hasClose="false" />
    <ModalAlert ref="modalUpdatePercentSuccess" text="บันทึกสำเร็จ" />
    <ModalAlertError ref="modalUpdatePercentAlert" :text="textAlert" />
  </form>
</template>

<script>
import { required, between, numeric } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";

export default {
  name: "InventoryAutoConfig",
  components: {
    InputText,
    ModalLoading,
    ModalAlert,
    ModalAlertError,
  },
  created() {
    this.getStockDistributePercent();
  },
  beforeDestroy() {
    localStorage.controlTabInventory = 2;
  },
  data() {
    return {
      isBusy: false,
      distributePercentList: [],
      items: [],
      itemsUpdate: [],
      fields: [
        {
          key: "percent",
          label: "",
          class: "w-100px text-nowrap",
        },
      ],
      textAlert: "",
      isWarningDup: false,
    };
  },
  validations() {
    const rules = { items: { $each: {} } };
    const isDuplicateValue = () => {
      var answers = this.items[1];
      var keys = Object.keys(answers);
      var dupe = false;

      for (var i = 0; i < keys.length; i++) {
        for (var j = i + 1; j < keys.length; j++) {
          if (keys[i] !== "totalPercent" && keys[i] !== "percent") {
            if (answers[keys[i]] == answers[keys[j]]) {
              dupe = true;
              break;
            }
          }
        }
        if (dupe) {
          break;
        }
      }

      this.isWarningDup = dupe;
      return dupe;
    };

    this.fields.forEach((item, index) => {
      if (item.key !== "percent" && item.key !== "totalPercent") {
        rules.items.$each[`${item.key}`] = {
          required: required,
          between: between(0, 100),
          numeric: numeric,
          isDuplicateValue(value, value2) {
            let index = this.items.findIndex(
              (el) => el.percent == value2.percent
            );

            if (index == 1) {
              return !isDuplicateValue();
            } else {
              return true;
            }
          },
        };
      } else {
        rules.items.$each[`${item.key}`] = {};
      }
    });
    return rules;
  },
  methods: {
    async onSubmit() {
      let id = "";
      this.$v.items.$touch();
      if (this.$v.items.$error) {
        return;
      }
      this.$refs.modalLoadingUpdatePercent.show();

      for (const key in this.items[0]) {
        if (key !== "percent" && key !== "totalPercent") {
          this.distributePercentList.forEach((element) => {
            if (
              key.toLowerCase() ===
              element.branchName.toLowerCase().replaceAll(" ", "")
            ) {
              id = element.branchId;
              this.itemsUpdate.forEach((item) => {
                if (id === item.branchId) {
                  item.stockPercentDistribute = this.items[0][key];
                  item.lowStockPercentDistribute = this.items[1][key];
                }
              });
            }
          });
        }
      }
      await this.updateStockDistributePercent();
      this.getStockDistributePercent();
    },
    async getStockDistributePercent() {
      await this.axios.get(`${this.$baseUrl}/stockdistribute`).then((data) => {
        this.distributePercentList = data.detail;
        let tastList = data.detail.map((el) => {
          let key = el.branchName.replace(" ", "");
          return {
            key: key,
            label: el.branchName,
            class: "w-100px text-nowrap",
          };
        });
        let itemList = { percent: "สัดส่วนสินค้าปกติ", totalPercent: 0 };
        let itemList2 = { percent: "สัดส่วนสินค้าเหลือน้อย", totalPercent: 0 };

        data.detail.map((el) => {
          let fielName = el.branchName.replace(" ", "");
          itemList[`${fielName}`] = el.stockPercentDistribute;
          itemList.totalPercent =
            itemList.totalPercent + el.stockPercentDistribute;

          itemList2[`${fielName}`] = el.lowStockPercentDistribute;
          itemList2.totalPercent =
            itemList2.totalPercent + el.lowStockPercentDistribute;
        });

        this.items[0] = itemList;
        this.items[1] = itemList2;
        let tempList = [];
        tempList[0] = itemList;
        tempList[1] = itemList2;
        this.items = tempList;
        this.fields = this.fields.concat(tastList);
        this.fields.push({
          key: "totalPercent",
          label: "% รวม",
          class: "w-100px text-nowrap",
        });

        this.itemsUpdate = [];
        this.distributePercentList.forEach((element) =>
          this.itemsUpdate.push({
            branchId: element.branchId,
            stockPercentDistribute: element.stockPercentDistribute,
            lowStockPercentDistribute: element.lowStockPercentDistribute,
          })
        );
      });
    },
    async updateStockDistributePercent() {
      await this.axios
        .post(`${this.$baseUrl}/stockdistribute`, this.itemsUpdate)
        .then((data) => {
          this.$refs.modalLoadingUpdatePercent.hide();
          if (data.result == 0) {
            this.textAlert = data.detail;
            this.$refs.modalUpdatePercentAlert.show();
          } else {
            this.$refs.modalUpdatePercentSuccess.show();
          }
        });
    },
    sumPercent(row) {
      let total = 0;
      this.items[row].totalPercent = 0;

      for (const key in this.items[row]) {
        if (
          key !== "percent" &&
          key !== "totalPercent" &&
          this.items[row][key] !== "" &&
          this.items[row][key] > 0
        ) {
          total += parseInt(this.items[row][key]);
        }
      }
      this.items[row].totalPercent = total;
    },
    checkSamePercent(index) {
      let arrPercent = [];
      for (const key in this.distributePercentList) {
        if (this.distributePercentList[key].lowStockPercentDistribute != "") {
          arrPercent.push(
            this.distributePercentList[key].lowStockPercentDistribute.toString()
          );
        }
      }
      let toFindDuplicates = [];

      toFindDuplicates = arrPercent.filter(
        (item, index) => arrPercent.indexOf(item) !== index
      );
      if (
        toFindDuplicates.length > 0 &&
        toFindDuplicates.indexOf(
          this.distributePercentList[index].lowStockPercentDistribute.toString()
        ) != -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    cancle() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-container {
  min-width: 150px;
}
.error-container {
  position: relative;
}

.error-custom {
  position: absolute;
  font-size: 12px;
}
/deep/ .table td {
  text-align: center;
  border: none;
  vertical-align: baseline;
}
.text-error {
  color: #ff0000;
  padding-left: 1rem;
}
</style>
